import { create } from 'zustand';

interface AppState {
  shouldShowSpinner: boolean;
  setShouldShowSpinner: (shouldShowSpinner: boolean) => void;
}

export const useAppStore = create<AppState>((set, get) => ({
  shouldShowSpinner: false,
  setShouldShowSpinner: (shouldShowSpinner: boolean) => {
    set({ shouldShowSpinner });
  }
}));
